import React from 'react';

import CircleDiagram from './CircleDiagram';
import Header from './Header';

const Intro = () => {
    return (
        <div className={'ohs-intro'}>
            <Header/>

            <div className={'ohs-intro__content ohs-content-padding'}>
                <div className={'ohs-intro__left'}>
                    <h2 className={'ohs-intro__heading'}>Introduction</h2>
                    <p className={'ohs-intro__text'}>
                        A healthy organization is one that has less politics and confusion, higher morale and
                        productivity, lower unwanted turnover, and lower recruiting costs than an unhealthy one. No
                        leader would dispute the power of these qualities, and every leader would love his or her
                        organization to have them. Unfortunately, most of us struggle with how to make this happen. The
                        primary purpose of this report is to provide a simple indicator of the relative health of your
                        organization as well as help you interpret and act on your results. Hopefully, this will relieve
                        some of the struggle.
                    </p>
                </div>
                <div className={'ohs-intro__right'}>
                    <CircleDiagram size={300}/>
                </div>
            </div>
        </div>
    );
};

export default Intro;
